var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    height: 67.5,
    viewBox: "0 0 494 67.5",
    style: {
      enableBackground: "new 0 0 494 67.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#0F293D;}\r\n\t.st2{display:none;}\r\n\t.st3{display:inline;fill:#0F293D;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:#F7BF00;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -148.5,
    y: -246.1,
    className: "st0",
    width: 792,
    height: 612
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "179.7,14.4 179.7,0 129.1,0 112.5,0 112.5,14.4 112.5,25.7 112.5,40.1 112.5,53.1 112.5,63.6  112.5,67.4 179.7,67.4 179.7,53.1 129.1,53.1 129.1,40.1 165.3,40.1 165.3,25.7 129.1,25.7 129.1,14.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "438.3,53.1 438.3,0 421.8,0 421.8,53.1 421.8,63.6 421.8,67.4 488.9,67.4 488.9,53.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.3,
    className: "st1",
    width: 16.5,
    height: 67.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "82,0 51.6,41.9 21,0 4.6,0 4.6,67.4 21.1,67.4 21.1,27.4 51.6,67.4 82.1,27.4 82.1,67.4 98.6,67.4  98.6,0  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246,0.4c-0.8-0.2-1.5-0.3-2.3-0.4h-10h-24.1h-16.5v14.4v38.7v10.6v3.8h40.6h10c0.8-0.1,1.5-0.2,2.3-0.4 c15.3-3.3,26.8-17,26.8-33.3C272.9,17.4,261.4,3.7,246,0.4z M241,53.1h-4.4h-25.9c-0.4-0.5-0.7-1.1-1-1.6V16 c0.3-0.5,0.7-1.1,1-1.6h25.9h4.4c9.7,1.1,17.3,9.4,17.3,19.4C258.3,43.7,250.7,52,241,53.1z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20.7,92.8c-2.3-0.9-3.5-1.3-5.8-1.3c-2.5,0-5.4,0.9-5.4,4.1c0,5.9,13.4,4.5,13.4,14.7 c0,6.6-5.1,9.2-11.4,9.2c-2.2,0-4.3-0.6-6.4-1.3l0.4-4.1c1.5,0.6,4.2,1.5,6.5,1.5c2.5,0,6.1-1.4,6.1-5c0-6.9-13.4-5-13.4-14.6 c0-5.5,4.4-8.4,10-8.4c2.1,0,4.5,0.4,6.6,1.1L20.7,92.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.1,88.1h17.4V92h-13v9h11.8v3.9H33.5V115h13v3.9H29.1V88.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M53.4,88.1H61c6.1,0,12.1,1,12.1,8.3c0,3.7-2.8,6.4-6.4,7v0.1c1.4,0.5,2,1.2,3,3.1l5.9,12.3h-5.1 l-4.8-10.7c-1.4-3-2.8-3-5.2-3h-2.7v13.7h-4.5V88.1H53.4z M57.8,101.4h3.8c4.2,0,6.7-1.9,6.7-4.8c0-2.8-2.1-4.5-6.2-4.5h-4.3 C57.8,92.1,57.8,101.4,57.8,101.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M93.6,118.9H88L76.3,88.1h5l9.6,26.9H91l9.8-26.9h4.7L93.6,118.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M109.7,88.1h4.5v30.8h-4.5V88.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M143.6,93.2c-2-1.1-4.1-1.7-6.4-1.7c-7.2,0-11.9,5.1-11.9,12c0,7.2,5.3,12,11.7,12c2.2,0,5.2-0.6,6.8-1.5 l0.3,4.3c-2.4,1-5.3,1.1-7.1,1.1c-9.8,0-16.4-6.3-16.4-16.1c0-9.5,6.9-15.8,16.4-15.8c2.4,0,4.8,0.4,7,1.3L143.6,93.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M149.6,88.1H167V92h-13v9h11.8v3.9H154V115h13v3.9h-17.4V88.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M188.2,92.8c-2.3-0.9-3.5-1.3-5.8-1.3c-2.5,0-5.4,0.9-5.4,4.1c0,5.9,13.4,4.5,13.4,14.7 c0,6.6-5.1,9.2-11.4,9.2c-2.2,0-4.3-0.6-6.4-1.3l0.4-4.1c1.5,0.6,4.2,1.5,6.5,1.5c2.5,0,6.1-1.4,6.1-5c0-6.9-13.4-5-13.4-14.6 c0-5.5,4.4-8.4,10-8.4c2,0,4.5,0.4,6.6,1.1L188.2,92.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M194.1,105.4h11.5v3.4h-11.5V105.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M232.7,93.2c-2-1.1-4.1-1.7-6.4-1.7c-7.2,0-11.9,5.1-11.9,12c0,7.2,5.3,12,11.7,12c2.2,0,5.2-0.6,6.8-1.5 l0.3,4.3c-2.4,1-5.3,1.1-7.1,1.1c-9.9,0-16.4-6.3-16.4-16.1c0-9.5,6.9-15.8,16.4-15.8c2.4,0,4.8,0.4,7,1.3L232.7,93.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M251.8,87.6c9.4,0,15,6.8,15,15.9c0,9.4-5.5,15.9-15,15.9s-15-6.6-15-15.9 C236.8,94.4,242.4,87.6,251.8,87.6z M251.8,115.6c7.2,0,10.2-5.9,10.2-12c0-6.3-3.4-12.1-10.2-12c-6.9,0-10.2,5.8-10.2,12 C241.6,109.7,244.6,115.6,251.8,115.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M273,88.1h6.1l13.7,24.8h0.1V88.1h4.5v30.8h-5.7l-14.1-25.3h-0.1v25.3H273V88.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M319.4,92.8c-2.3-0.9-3.5-1.3-5.8-1.3c-2.5,0-5.4,0.9-5.4,4.1c0,5.9,13.4,4.5,13.4,14.7 c0,6.6-5.1,9.2-11.4,9.2c-2.2,0-4.3-0.6-6.4-1.3l0.4-4.1c1.5,0.6,4.2,1.5,6.5,1.5c2.5,0,6.1-1.4,6.1-5c0-6.9-13.4-5-13.4-14.6 c0-5.5,4.4-8.4,10-8.4c2,0,4.5,0.4,6.6,1.1L319.4,92.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M327.7,88.1h17.4V92h-13v9H344v3.9h-11.8V115h13v3.9h-17.4V88.1H327.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M352.3,88.1h4.5v30.8h-4.5V88.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M364.6,88.1h4.5V115h13v3.9h-17.5V88.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M401.1,92.8c-2.3-0.9-3.5-1.3-5.8-1.3c-2.5,0-5.4,0.9-5.4,4.1c0,5.9,13.4,4.5,13.4,14.7 c0,6.6-5.1,9.2-11.4,9.2c-2.2,0-4.3-0.6-6.4-1.3l0.4-4.1c1.5,0.6,4.2,1.5,6.5,1.5c2.5,0,6.1-1.4,6.1-5c0-6.9-13.4-5-13.4-14.6 c0-5.5,4.4-8.4,10-8.4c2,0,4.5,0.4,6.6,1.1L401.1,92.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M406.9,105.4h11.5v3.4h-11.5V105.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M438.2,92.8c-2.3-0.9-3.5-1.3-5.8-1.3c-2.5,0-5.4,0.9-5.4,4.1c0,5.9,13.4,4.5,13.4,14.7 c0,6.6-5.1,9.2-11.4,9.2c-2.2,0-4.3-0.6-6.4-1.3l0.4-4.1c1.5,0.6,4.2,1.5,6.5,1.5c2.5,0,6.1-1.4,6.1-5c0-6.9-13.4-5-13.4-14.6 c0-5.5,4.4-8.4,10-8.4c2,0,4.5,0.4,6.6,1.1L438.2,92.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M460.4,92.8c-2.3-0.9-3.5-1.3-5.8-1.3c-2.5,0-5.4,0.9-5.4,4.1c0,5.9,13.4,4.5,13.4,14.7 c0,6.6-5.1,9.2-11.4,9.2c-2.2,0-4.3-0.6-6.4-1.3l0.4-4.1c1.5,0.6,4.2,1.5,6.5,1.5c2.5,0,6.1-1.4,6.1-5c0-6.9-13.4-5-13.4-14.6 c0-5.5,4.4-8.4,10-8.4c2,0,4.5,0.4,6.6,1.1L460.4,92.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M474.8,92h-9.7v-3.9h23.8V92h-9.7v26.9h-4.5V92H474.8z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 314.4,
    className: "st4",
    width: 93.7,
    height: 67.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "361.4,0 408.1,67.4 408.1,0 314.4,0 314.4,67.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "390.9,67.4 361.3,26.5 332,67.4"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.3bee4dda2da510dcff127fd97d4d945e.svg";
export { ForwardRef as ReactComponent };